/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Rating_ThanksInputs */

const en_us2_engagement_rating_thanks = /** @type {(inputs: Engagement_Rating_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glad to hear it! A Play Store review helps a lot.`)
};

const pt_br2_engagement_rating_thanks = /** @type {(inputs: Engagement_Rating_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que bom! Uma avaliação na Play Store ajuda muito.`)
};

const es_419_engagement_rating_thanks = /** @type {(inputs: Engagement_Rating_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Qué bueno! Una reseña en Play Store ayuda mucho.`)
};

const pt_pt2_engagement_rating_thanks = /** @type {(inputs: Engagement_Rating_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda bem! Uma avaliação na Play Store ajuda muito.`)
};

const fr_fr2_engagement_rating_thanks = /** @type {(inputs: Engagement_Rating_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Super ! Un avis sur le Play Store nous aide beaucoup.`)
};

const de_de2_engagement_rating_thanks = /** @type {(inputs: Engagement_Rating_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freut uns! Eine Bewertung im Play Store hilft sehr.`)
};

const it_it2_engagement_rating_thanks = /** @type {(inputs: Engagement_Rating_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che bello! Una recensione sul Play Store aiuta molto.`)
};

/**
* | output |
* | --- |
* | "Glad to hear it! A Play Store review helps a lot." |
*
* @param {Engagement_Rating_ThanksInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_rating_thanks = /** @type {((inputs?: Engagement_Rating_ThanksInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Rating_ThanksInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_rating_thanks(inputs)
	if (locale === "es-419") return es_419_engagement_rating_thanks(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_rating_thanks(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_rating_thanks(inputs)
	if (locale === "de-DE") return de_de2_engagement_rating_thanks(inputs)
	if (locale === "it-IT") return it_it2_engagement_rating_thanks(inputs)
	return en_us2_engagement_rating_thanks(inputs)
});
export { engagement_rating_thanks as "engagement.rating_thanks" }